<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">MDFE</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/mdfe"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="manifestoId"
                    pagination-path="meta"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:loaded="onLoaded"
                    detail-row-component="mdfe-detalhes"
                  >
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <span v-if="props.rowData.livStatus.valor == 6"
                          ><a
                            @click="onEvento(props.rowData, 11)"
                            v-b-tooltip
                            title="Encerrar MDFE"
                            ><i class="fa fa-thumbs-o-up"></i></a
                        ></span>
                        <span v-if="props.rowData.livStatus.valor == 6"
                          ><a
                            @click="onEvento(props.rowData, 4)"
                            v-b-tooltip
                            title="Cancelar MDFE"
                            v-if="getPermission('mdfe.cancelar')"
                            ><i class="fa fa-times-circle"></i></a
                        ></span>
                        <span
                          v-if="
                            props.rowData.livStatus.valor == 6 ||
                            props.rowData.livStatus.valor == 11 ||
                            props.rowData.livStatus.valor == 21
                          "
                          ><a
                            @click="onImprimir(props.rowData)"
                            v-b-tooltip
                            title="Imprimir MDFE"
                            ><i class="fa fa-print"></i></a
                        ></span>
                        <span v-if="props.rowData.manifestoXml.length > 0"
                          ><a
                            @click="onDownloadXml(props.rowData.manifestoId)"
                            v-b-tooltip
                            title="Download Xml"
                            ><i class="fa fa-download"></i></a
                        ></span>
                        <a
                          v-if="
                            props.rowData.livStatus.valor == 1 ||
                            props.rowData.livStatus.valor == 8 ||
                            props.rowData.livStatus.valor == 7
                          "
                          @click="onReenvioMdfe(props.rowData.manifestoId)"
                          v-b-tooltip
                          title="Reenviar MDFE"
                          ><i class="fa fa-undo"></i
                        ></a>
                        <a
                          v-if="
                            (props.rowData.livStatus.valor == 6 ||
                              props.rowData.livStatus.valor == 21) &&
                            props.rowData.statusEnvioTerceiro.valor == 3
                          "
                          @click="onReenvioErp(props.rowData.manifestoId)"
                          v-b-tooltip
                          title="Reenvio MDFE Erp"
                          ><i class="fa fa-reply"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                        <span v-if="props.rowData.livStatus.valor == 6">
                          <a
                            @click="onAddLacre(props.rowData)"
                            v-b-tooltip
                            title="Adicionar lacre"
                            ><i class="fa fa-tags"></i
                          ></a>
                        </span>
                      </div>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.livStatus.valor == 14"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="props.rowData.livStatus.valor == 21"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.livStatus.valor == 34"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.livStatus.valor == 31"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.livStatus.valor == 9"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.livStatus.valor == 8"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.livStatus.valor == 7"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.livStatus.valor == 22"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.livStatus.valor == 12"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.livStatus.valor == 6"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="props.rowData.livStatus.valor == 3"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="props.rowData.livStatus.valor == 32"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="props.rowData.livStatus.valor == 2"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.livStatus.valor == 1"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.livStatus.valor == 4"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.livStatus.valor == 5"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.livStatus.valor == 11"
                        >{{ props.rowData.livStatus.descr }}</span
                      >
                    </template>
                    <template slot="statusEnvioTerceiro" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.statusEnvioTerceiro.valor == 1"
                        >{{ props.rowData.statusEnvioTerceiro.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.statusEnvioTerceiro.valor == 2"
                        >{{ props.rowData.statusEnvioTerceiro.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.statusEnvioTerceiro.valor == 3"
                        >{{ props.rowData.statusEnvioTerceiro.descr }}</span
                      >
                    </template>
                    <template slot="transportadora" slot-scope="props">
                      <span v-if="props.rowData.transportadora != null">{{
                        props.rowData.transportadora
                      }}</span>
                    </template>
                    <template slot="motorista" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.manifestoRodo != null &&
                          props.rowData.manifestoRodo.manifestoRodoMotorista
                            .length > 0
                        "
                        >{{
                          props.rowData.manifestoRodo.manifestoRodoMotorista[0]
                            .nome
                        }}</span
                      >
                    </template>
                    <template slot="transportadora_cnpj" slot-scope="props">
                      <span v-if="props.rowData.transportadoraCnpj != null">{{
                        ajustaMascara(
                          onFormataCnpj(
                            props.rowData.transportadoraCnpjBase,
                            props.rowData.transportadoraCnpjFilial,
                            props.rowData.transportadoraCnpjDigito
                          ),
                          2
                        )
                      }}</span>
                    </template>

                    <template slot="unidade_transporte" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.bModal == 3 &&
                          props.rowData.manifestoAqua != null
                        "
                      >
                        <span
                          >{{ props.rowData.manifestoAqua.embarcacao.cd }}-{{
                            props.rowData.manifestoAqua.numViagem
                          }}</span
                        >
                      </span>
                      <span
                        v-if="
                          props.rowData.manifestoRodo != null &&
                          props.rowData.bModal == 1
                        "
                      >
                        <span>{{
                          props.rowData.manifestoRodo.manifestoRodoTracao.placa
                        }}</span>
                      </span>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LacreModalForm ref="lacremodalform"> </LacreModalForm>
  </div>
</template>

<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import MdfeFilterBar from "./MdfeFilterBar";
import LacreModalForm from "./LacreModalForm.vue";
import MdfeDetalhes from "./MdfeDetalhes";
import moment from "moment";

Vue.component("mdfe-detalhes", MdfeDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    LacreModalForm,
    "vuetable-filterbar": MdfeFilterBar,
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      manifesto_id: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      formimprimir: new Form({
        doc_id: "",
        manifesto_id: "",
        tp_print: "",
      }),
      helpForm: new Form({ statusRecord: [], params: [], manifesto_id: "" }),
      form: new Form({
        manifesto_id: "",
        tp_evento: "",
      }),
      fields: [
        {
          name: "numFiscal",
          title: "Nº Fiscal",
        },
        {
          name: "dtEmi",
          title: "Data Emissão",
          callback: "formatDate|DD/MM/YYYY HH:mm",
        },
        {
          name: "livTipoDoc.descr",
          title: "Modal",
        },
        {
          name: "__slot:unidade_transporte",
          title: "Unidade Transporte",
        },
        {
          name: "__slot:motorista",
          title: "Motorista",
        },
        {
          name: "__slot:transportadora",
          title: "Transportadora",
        },
        {
          name: "__slot:transportadora_cnpj",
          title: "CNPJ - Transportadora",
        },
        {
          name: "ufCarreg",
          title: "UF Carregamento",
        },
        {
          name: "ufDescarreg",
          title: "UF Descarregamento",
        },
        {
          name: "__slot:status",
          title: "Status",
        },
        {
          name: "__slot:statusEnvioTerceiro",
          title: "Status ERP",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
        detailRowClass: "vuetable-detail-row",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        num_fiscal: data_filter.num_fiscal,
        chave_mdfe: data_filter.chave_mdfe,
        num_fiscal_ini: data_filter.num_fiscal_ini,
        num_fiscal_fim: data_filter.num_fiscal_fim,
        dt_emi_ini: data_filter.dt_emi_ini,
        dt_emi_fim: data_filter.dt_emi_fim,
        num_cte_ini: data_filter.num_cte_ini,
        num_cte_fim: data_filter.num_cte_fim,
        porto_origem: data_filter.porto_origem.value,
        porto_destino: data_filter.porto_destino.value,
        consulta_completa: data_filter.consulta_completa,
        status: data_filter.status.value,
        embarcacao: data_filter.embarcacao.value,
        evento: data_filter.evento.value,
        transportadora: data_filter.transportadora.pessoa_id,
      };
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    formatDate(value, fmt = "D MMM YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatNumberCarga(value) {
      return accounting.formatNumber(value, 3, ".", ",");
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.manifestoId);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onAddLacre(data) {
      this.$refs.lacremodalform.onCreate(data);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    ajustaMascara(data, tipo) {
      if (tipo === 1) {
        //cpf
        return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      if (tipo === 2) {
        //cnpj
        return data.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
    },
    onEvento(data, tp_evento) {
      let form = this.form;
      console.log(data);

      var vm = this;
      const onConfirmWrapper = () => {
        confirmFn(vm, tp_evento, data.manifestoId);
      };

      let confirmFn = function (vm, tp_evento, manifesto_id) {
        console.log(manifesto_id);
        vm.form.manifesto_id = manifesto_id;
        vm.form.tp_evento = tp_evento;

        vm.form
          .post("/api/mdfe/evento")
          .then((response) => {
            new ReturnApi(response, vm);
          })
          .catch((errors) => {
            new ReturnApi(errors, vm, false, false, false, false);
          });
      };

      if (tp_evento == 4) {
        var vv_descr_evento = "Cancelar";
      } else if (tp_evento == 11) {
        var vv_descr_evento = "Encerrar";
      } else if (tp_evento == 12) {
        var vv_descr_evento = "Liberar";
      }

      let obj = {
        title: "Você deseja " + vv_descr_evento + " o MDFE ?",
        message: "Esta ação é irreversível",
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmWrapper,
      };

      this.$Simplert.open(obj);

      /*
            let dados = data;
            let form = this.form;


            let swal = this.$swal;
            let ref = this.$refs;
            this.$swal({
                  title: 'Você deseja encerrar o MDFE ?',
                  text: "Esta ação é irreversível",
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Sim, encerrar!',
                  cancelButtonText: 'Não',
                }).then(function () {
                    $(this).loading = true;
                    $(this).isDisabled = true;

                }, function (dismiss) {
                        // Cancel
                });
                */
    },
    onImprimir(data) {
      this.helpForm.manifesto_id = data.manifestoId;
      this.helpForm
        .post("/api/mdfe/imprimir")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onDownloadXml(manifesto_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.manifesto_id = manifesto_id;
      this.formimprimir
        .post("/api/mdfe/downloadxml")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onReenvioMdfe(manifesto_id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.manifesto_id = manifesto_id;
      this.form
        .post("/api/mdfe/reenvio")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    onReenvioErp(manifesto_id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.manifesto_id = manifesto_id;
      this.form
        .post("/api/mdfe/reenvioerp")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
          Vue.nextTick(() => this.$refs.vuetable.refresh());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
